<article class="grid-wrapper">
  @if (loading()) {
    <div class="state-row">
      <div class="spinner-wrapper">
        <app-spinner size="m" type="ripple" />
        <p>{{ 'pages.roles.states.loading' | translate }}</p>
      </div>
    </div>
  } @else if (roles().length === 0) {
    <div class="state-row">
      <span>{{ 'pages.roles.states.empty' | translate }}</span>
    </div>
  } @else {
    <app-responsive-table
      [items]="roles()"
      [columns]="columns()"
      [actions]="actions()"
      [showActions]="!readOnly()"
      [maxInlineActions]="3"
      [trackBy]="trackByRole"
      (actionSelected)="onActionSelected($event)"
      [paginated]="true"
      [page]="pageNumber()"
      [pageSize]="pageSize()"
      [totalItems]="totalItems()"
      (pageChange)="onPageChange($event)"
    />
  }
</article>
